import { render, staticRenderFns } from "./RoomInventory.vue?vue&type=template&id=3aedf562&"
import script from "./RoomInventory.vue?vue&type=script&lang=js&"
export * from "./RoomInventory.vue?vue&type=script&lang=js&"
import style0 from "./RoomInventory.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports